export const MIMETYPE_MAPPER: Record<string, string[]> = {
  'image/*': ['jpeg', 'jpg', 'png', 'gif', 'svg'],
  'application/pdf': ['pdf'],
  'video/*': ['mp4', 'webm', 'ogg'],
  'application/msword': ['doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    'docx',
  ],
  'application/vnd.ms-excel': ['xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
  'application/vnd.ms-powerpoint': ['ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
    'pptx',
  ],
}

export const mimeTypeToExtensions = (
  mimeTypes: (string | keyof typeof MIMETYPE_MAPPER)[],
): string[] =>
  mimeTypes.reduce<string[]>((acc, type) => {
    // Se for algo que temos no mapper
    if (MIMETYPE_MAPPER[type]) {
      acc.push(...MIMETYPE_MAPPER[type])
      return acc
    }

    // Se for extensão direta (".doc", ".pptx", etc.)
    if (type.startsWith('.')) {
      acc.push(type.replace('.', ''))
      return acc
    }

    // fallback: tenta pegar depois da "/" apenas se não for "*"
    const [, extension] = type.split('/')
    if (extension && extension !== '*') {
      acc.push(extension)
    }

    return acc
  }, [])
